import React, { useState, useEffect } from "react";
import { Button, Stack, Box, useMediaQuery, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector, useDispatch } from "react-redux";
import ExtraLinks from "./ExtraLinks";
import { selectAuthState, getAccountActivationDetails } from "../../../sagas/auth/authSlice";
import { useHistory } from "react-router";

const useStyles = makeStyles({
  input: {
    border: "none",
    outline: "none",
    background: "#FFFFFF",
    boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.1)",
    boxSizing: "border-box",
    borderRadius: "24px",
    height: "49px",
    maxWidth: "350px",
    width: "100%",
    padding: "0 10px",
    fontFamily: "Work Sans",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "22px",
    color: "#A8A8A8",
  },
  buttonProgress: {
    color: "#053742",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
});

export default function SearchSpecialCode() {
  const classes = useStyles();
  const matchesMobile = useMediaQuery("(max-width:380px)");
  const [specialCode, setSpecialCode] = useState("");
  const { accountActivationDetails, isFetching } = useSelector(selectAuthState);

  const navigation = useHistory();
  const dispatch = useDispatch();

  const searchSpecialCode = () => {
    dispatch({
      type: getAccountActivationDetails.type,
      payload: {
        activationToken: specialCode,
      },
    });
  };

  useEffect(() => {
    if (accountActivationDetails) {
      navigation.push("/completeregistration", {
        token: specialCode,
      });
    }
  }, [accountActivationDetails, navigation, specialCode]);

  const handleInput = (e: any) => {
    let targetValue = e.target.value.toUpperCase();
    if (targetValue?.length === 5 && targetValue[targetValue.length - 1] === "-") {
      setSpecialCode(targetValue);
    } else {
      targetValue = targetValue.replace(/-/g, "");
      if (targetValue === "" || /[0-9A-Z]/.test(targetValue[targetValue.length - 1])) {
        if (targetValue?.length <= 8) {
          if (targetValue?.length > 4) {
            targetValue = [targetValue.slice(0, 4), "-", targetValue.slice(4)].join("");
          }

          setSpecialCode(targetValue);
        }
      }
    }
  };

  return (
    <Stack direction="column" justifyContent="center" alignItems="center" spacing={4} sx={{ marginTop: "30px" }}>
      <Box sx={{ width: "100%" }}>
        <input placeholder="Enter your Special Code" value={specialCode} onChange={handleInput} className={classes.input} />
      </Box>

      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: "100%", flexDirection: matchesMobile ? "column" : "row" }}>
        <Button
          variant="outlined"
          sx={{
            width: matchesMobile ? "100%" : "200px",
            height: "49px",
            fontSize: "18px",
            borderRadius: "24px",
            textTransform: "none",
            color: "#39A2DB",
            transition: "background 0.55s, color 0.55s",
            borderColor: "#39A2DB",
            "&:hover": {
              backgroundColor: "#39A2DB",
              color: "white",
              borderColor: "#39A2DB",
            },
          }}
          href="/login"
        >
          I have an account
        </Button>
        <Button
          type="submit"
          variant="contained"
          style={{
            width: matchesMobile ? "100%" : "113px",
            marginTop: matchesMobile ? "20px" : "",
            height: "49px",
            fontSize: "18px",
            borderRadius: "24px",
            textTransform: "capitalize",
            color: "white",
            backgroundColor: specialCode ? "#39A2DB" : "rgba(211, 211, 211, 1)",
            borderColor: specialCode ? "#39A2DB" : "rgba(211, 211, 211, 1)",
          }}
          onClick={searchSpecialCode}
          disabled={!specialCode}
        >
          Confirm
          {isFetching ? <CircularProgress size={26} className={classes.buttonProgress} /> : <></>}
        </Button>
      </Stack>

      <ExtraLinks />
    </Stack>
  );
}
